import { z } from "zod";
import {
    REPORT_SETTINGS_TEMPLATE_DESCRIPTION_MAX_LENGTH,
    REPORT_SETTINGS_TEMPLATE_NAME_MAX_LENGTH,
} from "@common/constants/reports/report-settings-template";

export const ReportSettingsTemplateIdPathParamsSchema = z.object({
    reportSettingsTemplateId: z.string().uuid(),
});

const nameSchema = z
    .string()
    .trim()
    .min(1)
    .max(REPORT_SETTINGS_TEMPLATE_NAME_MAX_LENGTH);

const descriptionSchema = z
    .string()
    .max(REPORT_SETTINGS_TEMPLATE_DESCRIPTION_MAX_LENGTH)
    .nullable();

export const ReportSettingsTemplateCreateSchema = z.object({
    name: nameSchema,
    description: descriptionSchema.optional(),
    sourceTemplateId: z.string().uuid().nullable(),
});

export const ReportSettingsTemplateUpdateSchema = z
    .object({
        name: nameSchema.optional(),
        description: descriptionSchema.optional(),
    })
    .refine((body) => Object.keys(body).length > 0, {
        message: "At least one field must be provided",
    });

export const ReportSettingsTemplateSetDefaultSchema = z.object({
    templateId: z.string().uuid().nullable(),
});

export const ReportSettingsTemplateSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    isDefault: z.boolean(),
    isArchived: z.boolean(),
});

const ReportSettingsTemplateClientSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    iconColor: z.string().nullable(),
});

const ReportSettingsTemplateEntitySchema = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    iconColor: z.string(),
    logo: z.string().nullable(),
});

export const ReportSettingsTemplateListItemSchema = z.object({
    id: z.string().uuid().nullable(),
    name: z.string(),
    description: z.string().nullable(),
    isDefault: z.boolean(),
    isArchived: z.boolean(),
    clients: z.array(ReportSettingsTemplateClientSchema),
    entities: z.array(ReportSettingsTemplateEntitySchema),
    canDelete: z.boolean(),
});

export const ReportSettingsTemplateListResponseSchema = z.object({
    reportSettingsTemplates: z.array(ReportSettingsTemplateListItemSchema),
});

export type ReportSettingsTemplateListItem = z.infer<
    typeof ReportSettingsTemplateListItemSchema
>;
